@if (breakpointChanges$ | async; as isSmallScreen) {
  <button tdWbButton
          tdWbButtonType="secondary"
          id="td-wb-filter-button-toggle"
          class="td-wb-filter__toggle-button"
          (click)="showFilters()"
          [attr.title]="'tdWb.filters.SHOW_ADVANCED_FILTERS' | translate">

    @if (!isSmallScreen.matches) {
      <span class="td-wb-filter-button__icon-text">
      <td-wb-icon size="18"
                  iconId="filter--small"
                  class="td-wb-filter__toggle-button-icon" />
        @if (!hasFilter()) {
          <span translate="tdWb.filters.FILTERS"></span>
        }
        @if (hasFilter()) {
          <span [innerText]="('tdWb.filters.FILTERS' | translate) + ' (' + numberOfFilter + ')'"></span>
        }
  </span>
    }

    @if (isSmallScreen.matches) {
      <span [ngClass]="hasFilter() ? 'td-wb-filter-button__icon-text': 'td-wb-filter-button__icon-text--no-filter'">
      <td-wb-icon size="18"
                  iconId="filter--small"
                  class="td-wb-filter__toggle-button-icon" />
    <span class="td-wb-vh"
          translate="tdWb.filters.FILTERS"></span>
        @if (hasFilter()) {
          <span class="td-wb-filter__filter-number"
                [innerText]="' (' + numberOfFilter + ')'"></span>
        }
  </span>
    }
  </button>
}
